<script setup>
import FenixLogo from "./FenixLogo.vue";

const footerLinks = {
  producto: [
    { label: "Características", href: "#features" },
    { label: "Precios", href: "#pricing" },
    { label: "Demo", href: "#" },
  ],
  empresa: [
    { label: "Sobre nosotros", href: "#" },
    { label: "Seguridad", href: "#" },
    { label: "Cumplimiento", href: "#" },
  ],
  contacto: [
    { label: "Soporte", href: "#" },
    { label: "Ventas", href: "#" },
    { label: "Documentación técnica", href: "#" },
  ],
};
</script>

<template>
  <footer id="contact" class="bg-background border-t border-border/30 scroll-mt-20">
    <div class="container mx-auto px-6 py-16">
      <div class="grid md:grid-cols-4 gap-12 lg:gap-16">
        <!-- Logo and tagline -->
        <div class="md:col-span-1">
          <FenixLogo size="xl" class="mb-4" />
          <p class="text-sm text-muted-foreground mt-4">
            Control inteligente para equipos en remoto.
          </p>
        </div>

        <!-- Producto -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-4">
            Producto
          </h4>
          <ul class="space-y-3">
            <li v-for="(link, i) in footerLinks.producto" :key="i">
              <a 
                :href="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Empresa -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-4">
            Empresa
          </h4>
          <ul class="space-y-3">
            <li v-for="(link, i) in footerLinks.empresa" :key="i">
              <a 
                :href="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Contacto -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-4">
            Contacto
          </h4>
          <ul class="space-y-3">
            <li v-for="(link, i) in footerLinks.contacto" :key="i">
              <a 
                :href="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="mt-16 pt-8 border-t border-border/20">
        <p class="text-xs text-muted-foreground text-center">
          © Fenix Guardian Monitor. Todos los derechos reservados.
        </p>
      </div>
    </div>
  </footer>
</template>
